module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('boxWrap', {
    attrs: {
      "name": _vm.name,
      "min": true
    }
  }, [_c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "main"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-79c70e76!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/runda/dashboard/components/generatingData/index.vue
// module id = 2050
// module chunks = 2